import React from "react"
import ListTile from "./ListTile"
import { Icon } from "@blueprintjs/core"
import StatusIcon from "components/Atoms/StatusIcon"
import { readableDate } from "utils/custom.utils"

function TripSummary({ tripSummary }) {
  const vehicle = tripSummary?.vehicle
  const date = tripSummary?.date
  return (
    <>
      <ListTile
        className="mb-6"
        icon={<Icon icon="drive-time" intent="primary" />}
        title={vehicle?.registrationNumber}
        subtitle={vehicle?.vehicleType?.name}
      />
      <ListTile
        className="mb-6"
        icon={<Icon icon="user" intent="primary" />}
        title={tripSummary?.aggregator?.fullName}
        subtitle={tripSummary?.aggregator?.number}
      />
      <ListTile
        className="mb-6"
        icon={
          <Icon
            icon={tripSummary?.status === "CP" ? "endorsed" : "circle"}
            intent={tripSummary?.status === "CP" ? "success" : "primary"}
          />
        }
        title={
          <StatusIcon
            values={{
              OT: {
                text: "On Trip",
                intent: "warning",
                tooltip: "Trip is ongoing",
              },
              CP: {
                intent: "success",
                text: "Completed",
                tooltip: "Trip has been completed successfully!",
              },
              DS: {
                intent: "danger",
                text: "Discarded",
                tooltip: "Trip has been discarded",
              },
              NS: {
                intent: "primary",
                text: "Not Started",
                tooltip: "Trip has not started yet",
              },
              PS: {
                intent: "warning",
                text: "Paused",
                tooltip: "Trip has been paused",
              },
              IL: {
                intent: "danger",
                tooltip: "Trip is currently Idle",
                text: "Idle",
              },
            }}
            condition={tripSummary?.status}
          ></StatusIcon>
        }
        subtitle={readableDate(date)}
      />
      <ListTile
        className="mb-6"
        icon={<Icon icon="build" intent="primary" />}
        title="Unloading Team"
        subtitle={tripSummary?.unloadedBy?.name || "NA"}
      />
    </>
  )
}

export default TripSummary
